$(document).ready(function () {

    let owl = $('.carousel-modular-products').owlCarousel({
        items: 2,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: false,
        nav: false,
        responsive: {
            768: {
                items: 3,
                margin: 25
            },
            1199: {
                items: 4,
                margin: 30
            }
        }

    });

    $('.btn-back').on('click', function() {
        owl.trigger('prev.owl.carousel');
    })
    $('.btn-forward').on('click', function () {
        owl.trigger('next.owl.carousel');
    })

    let maxHeight = 0;
    $('.card-product').each(function () {
        if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
        }
    });
    $('.card-product').height(maxHeight);

    $('.carousel-publications-modular').owlCarousel({
        items: 1,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: true,
        nav: false,
        responsive: {
            768: {
                items: 2,
                margin: 30
            },
            992: {
                items: 3,
                margin: 30
            }
        }
    });

    let maxHeightPublication = 0;
    $('.card-publication-b').each(function () {
        if ($(this).outerHeight() > maxHeightPublication) {
            maxHeightPublication = $(this).outerHeight();
        }
    });
    $('.card-publication-b').height(maxHeightPublication);
});